import { useEffect, useState } from 'react'

// The value once it has stopped changing for `delay` ms, so typing into a
// server-backed search box sends one request per pause, not per keystroke.
export function useDebouncedValue(value, delay = 250) {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    if (debounced === value) return undefined
    const timer = window.setTimeout(() => setDebounced(value), delay)
    return () => window.clearTimeout(timer)
  }, [value, delay, debounced])
  return debounced
}
